export enum USER_ROLE {
  NO_AUTH = -1,
  ADMIN = 1,
  DEVELOPER,
  STAFF,
  CUSTOMER,
}
